import type { FormInputProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { Input } from '@/components';

import { FormFieldShell } from '../FormFieldShell';

export const FormInput = <TFieldValues extends FieldValues = FieldValues>(
  props: FormInputProps<TFieldValues>,
) => {
  const {
    name,
    label,
    hint,
    description,
    isRequired,
    placeholder,
    type = 'text',
    autoFocus,
    disabled,
    formatOnChange,
    inputProps,
    autoComplete,
  } = props;

  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <Input
          {...field}
          id={fieldId}
          type={type}
          label={label}
          aria-label={label}
          isRequired={isRequired}
          hint={hint}
          placeholder={placeholder ?? label}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          disabled={disabled}
          isInvalid={fieldState.invalid}
          aria-invalid={fieldState.invalid}
          value={field.value || ''}
          onChange={(e) => {
            const value = e.target.value;
            field.onChange(formatOnChange ? formatOnChange(value) : value);
          }}
          {...inputProps}
        />
      )}
    />
  );
};
